export const environment = {
  production: false,
  apiBaseUrl: 'https://api-registro-hml.lawservices.com.br/api',
  tipoSaas: 1
};
export default environment;
